import { useTheme } from "@mui/material/styles";
import {
  JsonView,
  allExpanded,
  darkStyles,
  defaultStyles,
} from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";

/**
 * Просмотр произвольного JSON (данные задачи, результат, опции).
 */
export function JSONView({ src }: { src: unknown }) {
  const theme = useTheme();

  if (src === null || src === undefined || typeof src !== "object") {
    return null;
  }

  return (
    <JsonView
      data={src as object}
      shouldExpandNode={allExpanded}
      style={theme.palette.mode === "dark" ? darkStyles : defaultStyles}
    />
  );
}
